import { TextInput, Textarea } from "@mantine/core"
import styled, { css } from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

const baseInputStyles = css`
    width: 100%;
    font-size: 14px;
    color: var(--custom-font-color);
    border-color: var(--custom-border-color);
`

const baseInputFieldStyles = css`
    border-radius: 8px;
    background-color: white;
    color: black;
    min-height: 48px;
`

export const NumberInput = styleWithOrgDesign(styled(TextInput)`
    ${baseInputStyles}

    & .mantine-TextInput-input {
        ${baseInputFieldStyles}
    }
`)

export const Input = styleWithOrgDesign(styled(Textarea)`
    ${baseInputStyles}

    & .mantine-Textarea-input {
        ${baseInputFieldStyles}
    }
`)
